// extracted by mini-css-extract-plugin
export default {"cls-1":"resource_cls-1__3k9RO","cls-2":"resource_cls-2__PZ6-h","cls-3":"resource_cls-3__eInlu","cls-4":"resource_cls-4__WwTiJ"};